import React from 'react';

const AydaCredit = ({ className = '' }) => (
  <p className={`flex items-center justify-center gap-1 text-[11px] tracking-wide text-muted-foreground/70 select-none ${className}`} data-testid="ayda-credit">
    <span className="uppercase font-medium">Crafted with care and</span>
    <span className="ayda-heart inline-flex" aria-label="love">
      <svg viewBox="0 0 24 24" fill="none" className="h-3.5 w-3.5" style={{ filter: 'drop-shadow(0 0 4px rgba(13,148,136,0.45))' }}>
        <path
          d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
          fill="#0d9488"
        />
      </svg>
    </span>
    <span className="uppercase font-medium">by the</span>
    <span className="font-bold uppercase" style={{ color: '#0d9488' }}>Ayda Team</span>
  </p>
);

export default AydaCredit;
